<div [ngClass]="['valuePreferencePanel p-col-12']">
  <div class="valuePreference-fields-container">
    <iu-input-text-ui
      data-cy="valuePreferencePanel-attribute"
      label="{{ 'valuePreference.attributeLabel' | translate }}"
      [fieldValue]="attributeDisplayValue"
      [isReadOnly]="true"
      [isStandalone]="true"
      [data]="{ marginTop: 10 }"
      [cssClass]="'p-col-12 p-md-12 p-lg-12'"></iu-input-text-ui>
    <iu-input-text-ui
      data-cy="valuePreferencePanel-value"
      label="{{ 'valuePreference.value' | translate }}"
      [fieldValue]="displayValue"
      [isReadOnly]="true"
      [isStandalone]="true"
      [data]="{ marginTop: 10 }"
      [cssClass]="'p-col-12 p-md-12 p-lg-12'"></iu-input-text-ui>
    <p data-cy="valuePreferencePanel-desc" class="help">{{ description }}</p>
  </div>
  <div class="valuePreference-checkbox-container">
    <iu-input-switch-ui
      data-cy="valuePreferencePanel-switch-client"
      label="{{ 'valuePreference.adClient' | translate }}"
      [fieldValue]="adClient"
      [isReadOnly]="true"
      [isStandalone]="true"
      cssGrid="p-col-6 p-md-6 p-lg-6"
      style="text-align: left"></iu-input-switch-ui>
    <iu-input-switch-ui
      data-cy="valuePreferencePanel-switch-org"
      label="{{ 'valuePreference.adOrg' | translate }}"
      [fieldValue]="adOrg"
      [isReadOnly]="adOrgReadOnly"
      [isStandalone]="true"
      cssGrid="p-col-6 p-md-6 p-lg-6"
      style="text-align: left"
      (fieldValueModified)="updateToggleValue('adOrg', $event)"></iu-input-switch-ui>
    <iu-input-switch-ui
      data-cy="valuePreferencePanel-switch-user"
      label="{{ 'valuePreference.adUser' | translate }}"
      [fieldValue]="adUser"
      [isReadOnly]="adUserReadOnly"
      [isStandalone]="true"
      cssGrid="p-col-6 p-md-6 p-lg-6"
      style="text-align: left"
      (fieldValueModified)="updateToggleValue('adUser', $event)">
    </iu-input-switch-ui>
    <iu-input-switch-ui
      data-cy="valuePreferencePanel-switch-window"
      label="{{ 'valuePreference.adWindow' | translate }}"
      [fieldValue]="adWindow"
      [isStandalone]="true"
      cssGrid="p-col-6 p-md-6 p-lg-6"
      style="text-align: left"
      (fieldValueModified)="updateToggleValue('adWindow', $event)">
    </iu-input-switch-ui>
  </div>
  <div class="valuePreference-btn-container">
    <button
      *ngIf="isDeletable"
      class="p-button p-button-secondary"
      data-cy="valuePreferencePanel-btn-delete"
      (click)="delete($event)">
      {{ 'valuePreference.delete' | translate }}
    </button>
    <button class="p-button p-button-secondary" data-cy="valuePreferencePanel-btn-cancel" (click)="cancel($event)">
      {{ 'valuePreference.cancel' | translate }}
    </button>
    <button class="p-button p-button-primary" data-cy="valuePreferencePanel-btn-save" (click)="save($event)">
      {{ 'valuePreference.save' | translate }}
    </button>
  </div>
</div>
